import type { I18nProvider, TranslationMessages } from 'react-admin';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import { replaceBrandName } from '../brandConfig/replaceBrandName';

export type LocaleType = 'en' | 'cn';

type LocaleTranslations = Record<LocaleType, TranslationMessages>;

export const i18nProviderFactory = ({ en, cn }: LocaleTranslations): I18nProvider => {
    const translations: LocaleTranslations = { en, cn };

    const baseProvider = polyglotI18nProvider(
        (locale: string) => translations[locale as LocaleType] ?? translations.en,
        'en', // default locale
        [
            { locale: 'en', name: 'English' },
            { locale: 'cn', name: '中文' },
        ],
    );

    const getBrandName = () =>
        (typeof window !== 'undefined' && (window as Window & { __BRAND_NAME__?: string }).__BRAND_NAME__) || '40Seas';

    const translate: I18nProvider['translate'] = (key, options) => {
        const brandName = getBrandName();
        const translated = baseProvider.translate(key, { ...(options ?? {}), brandName });
        return replaceBrandName(translated, brandName);
    };

    return {
        ...baseProvider,
        translate,
    };
};
